/* eslint-disable filename-rules/match -- versioned style-config files are named after the DLS version */

import { tagAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, theme } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const badgeTheme = theme.components?.Badge;
const tagTheme = theme.components?.Tag;

const variants = {
  subtle: definePartsStyle((props) => ({
    container: {
      ...badgeTheme.variants?.subtle(props),
      bg: 'grey.50',
    },
  })),
  solid: definePartsStyle((props) => ({
    container: {
      ...badgeTheme.variants?.solid(props),
      color: 'grey.300',
      bg: 'black',
    },
  })),
  outline: definePartsStyle((props) => ({
    container: {
      ...badgeTheme.variants?.outline(props),
    },
  })),
};

export const styleConfig = defineMultiStyleConfig({
  ...tagTheme,
  baseStyle: definePartsStyle({
    container: {
      ...tagTheme.baseStyle?.container,
      textTransform: 'uppercase',
      color: 'grey.600',
      minHeight: '20px',
      borderRadius: 'base',
    },
    label: {
      ...tagTheme.baseStyle?.label,
      fontSize: 'xs',
      letterSpacing: '0',
      fontWeight: '500',
    },
  }),
  variants,
  defaultProps: {
    variant: 'subtle',
  },
});
